import { Box, Table, Tbody, Td, Text, Tr } from "@chakra-ui/react";
import { GenericObjectType } from "@rjsf/utils";
import type { JSONSchema7Definition } from "json-schema";
import { FormattedMessage } from "react-intl";

import { RanaLoading } from "@nens/ranalib";

import { RESULT_SPACING } from "../consts/result-spacing";

interface ResultTableProps {
  properties: Record<string, JSONSchema7Definition>;
  values: GenericObjectType;
  isLoading?: boolean;
}

export function ResultTable({ properties, values, isLoading }: ResultTableProps) {
  return (
    <Table
      rounded="base"
      borderWidth="base"
      borderColor="brand.border"
      bg="brand.bg"
      variant="grid"
      mb={RESULT_SPACING}
      _last={{ mb: 0 }}
    >
      <Tbody>
        {Object.entries(properties).map(([key, property]) => {
          const value = values[key];
          const title = typeof property !== "boolean" ? property.title : undefined;
          const description = typeof property !== "boolean" ? property.description : undefined;

          let displayValue = (
            <Text fontWeight={600} fontStyle="italic">
              <FormattedMessage id="error.not_available" defaultMessage="Not available" />
            </Text>
          );

          if (isLoading) {
            displayValue = <RanaLoading />;
          }

          if (value != null && value !== undefined && value !== "" && typeof value !== "object") {
            displayValue = value;
          }

          return (
            <Tr key={key}>
              <Td w="xl" pl={4}>
                <Box w="fit">
                  <Text color="brand.clear_creek">{title}</Text>
                  <Text fontSize="sm">{description}</Text>
                </Box>
              </Td>
              <Td pl={4} alignContent="center">
                {displayValue}
              </Td>
            </Tr>
          );
        })}
      </Tbody>
    </Table>
  );
}
